import { persistUrlParams } from "@faire/help-center-utils/lib/persistUrlParams";
import { LoggedOutContactUsContextProvider } from "@faire/help-center/views/logged-out-contact-us/hooks/LoggedOutContactUsContextStore";
import { LoggedOutEmailContextProvider } from "@faire/help-center/views/logged-out-contact-us/hooks/LoggedOutEmailContextStore";
import { LoggedOutContactUsModal } from "@faire/help-center/views/logged-out-contact-us/surfaces/LoggedOutContactUsModal";
import { route as supportSelfServeRoute } from "@faire/web-api--source/routes/www/support/self-serve";
import React, { FC } from "react";
import { Redirect } from "react-router-dom";

import { LoginModal } from "../Login/LoginModal";

import { useContactStrategy } from "./hooks/useContactStrategy";

export const ContactStrategy: FC = () => {
  const { isUserLoggedIn, isLoggedOutExperience, shouldShowContactModal } =
    useContactStrategy();

  if (!shouldShowContactModal()) {
    return null;
  }

  if (!isLoggedOutExperience()) {
    if (!isUserLoggedIn()) {
      return <LoginModal />;
    }
    return (
      <Redirect to={persistUrlParams(supportSelfServeRoute, ["contact"])} />
    );
  }

  return (
    <LoggedOutContactUsContextProvider>
      <LoggedOutEmailContextProvider>
        <LoggedOutContactUsModal />
      </LoggedOutEmailContextProvider>
    </LoggedOutContactUsContextProvider>
  );
};
